import { motion } from "framer-motion";

import i1 from "./assets/Skillbased.svg";
import i2 from "./assets/Optimization.svg";
import i3 from "./assets/Absence.svg";
import i4 from "./assets/Powerfulreporting.svg";
import i5 from "./assets/ShiftSwapping.svg";

import "./Workforce.css";

const WorkforceBenefits = () => {
  const data = [
    {
      id: "skill-based-roster",
      title: "Skill based Roster",
      text: "JIVIEWS assigns skilled staff correctly and alerts shortages for any job.",
      icon: i1,
    },
    {
      id: "optimization",
      title: "Optimization",
      text: "JIVIEWS evaluates schedules and their impacts on performance at every location.",
      icon: i2,
    },
    {
      id: "absence-management",
      title: "Absence Management",
      text: "Manage employee leave efficiently to prevent shortages from last-minute absences.",
      icon: i3,
    },
    {
      id: "powerful-reporting",
      title: "Powerful reporting tool",
      text: "Generate filtered reports on absences, rosters, overtime, and other key KPIs easily.",
      icon: i4,
    },
    {
      id: "shift-swapping",
      title: "Shift Swapping",
      text: "JIVIEWS allows shift swaps with manager approval, balancing flexibility and control.",
      icon: i5,
    },
  ];

  return (
    <motion.section
      className="gate-functions-container"
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <motion.h2
        className="gate-functions-title"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
        viewport={{ once: true }}
      >
        How it benefits your organization?
      </motion.h2>

     
      <motion.div
        className="gate-functions-grid"
        initial={{ opacity: 0, scale: 0.96 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {data.map((item, index) => (
          <motion.div
            key={item.id}
            className="electric-card"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 + index * 0.1, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="electric-border" />

            <div className="electric-content">
              <div className="icon-wrapper">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="electric-icon"
                />
              </div>

              <h3 className="electric-title">{item.title}</h3>

              <p className="electric-text">{item.text}</p>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default WorkforceBenefits;
